const recommendationsCarouselConfig =
    (screenOverride = {}) =>
    (screenType) => {
        if (screenType === 'desktop') {
            return {
                slidesToScroll: 4,
                slidesToShow: 4.5,
                minProducts: 5,
                ...screenOverride?.desktop,
            };
        }
        if (screenType === 'tablet') {
            return {
                slidesToScroll: 3,
                slidesToShow: 3.5,
                minProducts: 4,
                ...screenOverride?.tablet,
            };
        }
        if (screenType === 'mobile') {
            return {
                slidesToScroll: 2,
                slidesToShow: 2.5,
                minProducts: 3,
                ...screenOverride?.mobile,
            };
        }
    };

export default recommendationsCarouselConfig;
